import { lazy, Suspense } from "react";
import PublicDashboard from "../pages/PublicDashboard";
import { AdminLoadingState, ContentLoadingState } from "./LoadingState";

const EstatisticasPage = lazy(() => import("../pages/EstatisticasPage"));
const ComoFuncionaPage = lazy(() => import("../pages/ComoFuncionaPage"));
const SobrePage = lazy(() => import("../pages/SobrePage"));
const AdminDashboard = lazy(() => import("../pages/AdminDashboard"));

function PublicPage({ currentPath, navigate, themeMode, toggleTheme }) {
  if (currentPath === "/estatisticas") {
    return <EstatisticasPage navigate={navigate} />;
  }
  if (currentPath === "/como-funciona") {
    return <ComoFuncionaPage navigate={navigate} />;
  }
  if (currentPath === "/sobre") {
    return <SobrePage navigate={navigate} />;
  }

  return (
    <PublicDashboard
      navigate={navigate}
      themeMode={themeMode}
      toggleTheme={toggleTheme}
    />
  );
}

export function AppRouter({
  currentPath,
  navigate,
  themeMode,
  toggleTheme,
}) {
  if (currentPath.startsWith("/admin")) {
    return (
      <Suspense fallback={<AdminLoadingState themeMode={themeMode} />}>
        <AdminDashboard />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<ContentLoadingState />}>
      <PublicPage
        currentPath={currentPath}
        navigate={navigate}
        themeMode={themeMode}
        toggleTheme={toggleTheme}
      />
    </Suspense>
  );
}
